export type ComposerLayout = "floating" | "bottom-sheet";

export function composerLayout(input: {
  viewport: { width: number; height: number };
}): ComposerLayout {
  const { width, height } = input.viewport;
  return width <= 1024 && width < height ? "bottom-sheet" : "floating";
}
